import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FeaturedMiniCard from "../../components/featured/FeaturedMiniCard";
import useTranslations from "@hooks/useTranslations";
const SubMenuFeatured = ({ featuredItems }) => {
    const { t } = useTranslations();
    if ((featuredItems === null || featuredItems === void 0 ? void 0 : featuredItems.length) < 1)
        return null;
    return (_jsxs("div", { className: "header__sub-menu-featured", children: [_jsx("div", { className: "header__sub-menu-featured-title", children: t("BDO.LiveSite.SubMenu.Featured") }), _jsx("div", { className: "header__sub-menu-featured-list", children: (featuredItems === null || featuredItems === void 0 ? void 0 : featuredItems.length) > 0 &&
                    featuredItems.map((fi, i) => (_jsxs("div", { children: [_jsx(FeaturedMiniCard, { featuredItem: fi }), _jsx("div", { className: "header__sub-menu-featured-list-divider" })] }, i))) })] }));
};
export default SubMenuFeatured;
